import React from 'react'
import CookieConsent from 'react-cookie-consent'
import { Content, Wrap, Button } from './index.styled'

const CookiesBanner = () => {
  const ref = React.useRef()
  const refCookie = React.useRef()

  React.useEffect(() => {
    setTimeout(() => {
      //ref?.current?.classList?.add('show')
      // refCookie.current?.accept()
    }, 0)
  }, [])

  return (
    <Wrap ref={ref} id={'cookie'}>
      <CookieConsent
        ref={refCookie}
        location="none"
        buttonText={'Accept'}
        disableStyles
        containerClasses="cookies-banner"
        buttonClasses="cookies-banner-accept-btn"
        disableButtonStyles
        enableDeclineButton
        buttonWrapperClasses="cookies-banner-btns"
        declineButtonClasses="cookies-banner-decline-btn"
        contentClasses="cookies-banner-content"
        expires={150}
        debug={true}
      >
        <Content>
          <>
            <div>
              This website uses cookies to ensure you get the best experience on
              our website.
            </div>
            <Button
              as="button"
              type="button"
              onClick={() => refCookie.current?.accept()}
              className="accept"
            >
              allow
            </Button>
          </>
        </Content>
      </CookieConsent>
    </Wrap>
  )
}
export default CookiesBanner
